module.exports = __webpack_public_path__ + "static/img/logo.9949608.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo.png
// module id = a58+
// module chunks = 26